import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnDestroy } from '@angular/core';
import { EventViewService } from 'src/app/services/event.view.service';
import { JoiAccount } from 'globals/store/accounts.data';
import { accountActions } from 'src/app/store/accounts.era';
import { JoiEvent } from 'globals/store/events.data';
import { accountsInvitedReselector } from 'src/app/store/reselectors/accounts.reselector';
import { invitedToEventsReselector } from 'src/app/store/reselectors/filteredEvents.reselector';
import { Wrapper } from '../wrapper.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { PhotoComponent } from '../photo';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'invitations',
    templateUrl: './invitations.html',
    styleUrls: ['./invitations.scss'],
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*', opacity: 1 })),
            state('collapse, undefined, void', style({ height: '0', padding: 0, opacity: 0 })),
            transition('* => collapse', [animate('1000ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    imports: [MatProgressSpinnerModule, MatProgressBarModule, MatButtonModule, PhotoComponent, CommonModule],
    standalone: true,
})
export class InvitationsComponent extends Wrapper<InvitationsComponent> implements OnDestroy {
  invitedAccounts: JoiAccount[]
  invitedToEvents: JoiEvent[]
  justInvitedAccountIds: string[] = []

  constructor(public eventViewService: EventViewService) {
    super()
    this.selectProp(accountsInvitedReselector, null, 'invitedAccounts')
    this.selectProp(invitedToEventsReselector, null, 'invitedToEvents')
    this.subProp(this.store.select('accounts', 'justInvitedIds'), 'justInvitedAccountIds')
  }

  declineInvitation(event) {
    this.eventService.decline(event)
    this.eventService.recentlyDeclined.add(event.eventId)
    setTimeout(() => {
      setTimeout(() => this.eventService.recentlyDeclined.delete(event.eventId), 500) // in case you want to enable multiple invites / declines per reload shennanigans 
    }, 1000)
  }

  viewEvent(event: JoiEvent) {
    this.eventService.openingEvent(null, event, false)
  }

  ngOnDestroy() {
    if (this.justInvitedAccountIds.length) {
      this.store.dispatch( accountActions.resetJustInvitedList())
    }
  }

  trackById(index, item) {
    return item.id
  }

  trackByEvent(index, event: JoiEvent) {
    return event.eventId
  }
}

